var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70903 2.85835C6.45519 2.60451 6.04364 2.60451 5.78979 2.85835L2.03979 6.60835C1.78595 6.86219 1.78595 7.27375 2.03979 7.52759L5.78979 11.2776C6.04364 11.5314 6.45519 11.5314 6.70903 11.2776C6.96287 11.0237 6.96287 10.6122 6.70903 10.3583L3.41865 7.06797L6.70903 3.77759C6.96287 3.52375 6.96287 3.11219 6.70903 2.85835Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1249 7.71797C14.1128 7.71797 15.0603 8.11042 15.7589 8.809C16.4574 9.50757 16.8499 10.455 16.8499 11.443C16.8499 12.4309 16.4574 13.3784 15.7589 14.0769C15.0603 14.7755 14.1128 15.168 13.1249 15.168H6.2499C5.89092 15.168 5.5999 15.459 5.5999 15.818C5.5999 16.177 5.89092 16.468 6.2499 16.468H13.1249C14.4576 16.468 15.7357 15.9385 16.6781 14.9962C17.6205 14.0538 18.1499 12.7757 18.1499 11.443C18.1499 10.1103 17.6205 8.83213 16.6781 7.88976C15.7357 6.94739 14.4576 6.41797 13.1249 6.41797H2.4999C2.14092 6.41797 1.8499 6.70898 1.8499 7.06797C1.8499 7.42695 2.14092 7.71797 2.4999 7.71797H13.1249Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.6206bfba65146549f16578b407f960ce.svg";
export { ForwardRef as ReactComponent };